// extracted by mini-css-extract-plugin
export default {"progressHeader":"progressLine_progressHeader__vOoNv"};